import { ArrowRight, Mail, Sparkles, Users } from "lucide-react";
import { InteractiveGraph } from "./InteractiveGraph";
import { Button } from "./ui/button";

export function Hero() {
	return (
		<section className="relative overflow-hidden pt-36 pb-20">
			{/* Background gradients & patterns */}
			<div className="pointer-events-none absolute inset-0 -z-10">
				<div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(15,157,138,0.25),_transparent_55%)]" />
				<div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_rgba(255,135,107,0.18),_transparent_60%)]" />
				<div className="absolute inset-0 bg-squash-grid opacity-30" />
			</div>
			<div className="absolute -top-20 -right-28 h-64 w-64 rounded-full bg-[radial-gradient(circle,_rgba(77,185,255,0.5),_transparent_60%)] blur-3xl" />
			<div className="absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-[radial-gradient(circle,_rgba(255,200,87,0.38),_transparent_60%)] blur-3xl" />

			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				<div className="grid items-center gap-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
					{/* Left column - Content */}
					<div className="space-y-9">
						<div className="inline-flex items-center gap-2 rounded-full border border-white/80 bg-white/70 px-5 py-2 text-sm text-muted-foreground shadow-md shadow-primary/10 backdrop-blur-xl">
							<Sparkles className="h-4 w-4 text-primary" />
							<span>
								Early Access is open for energetic Discord communities
							</span>
						</div>

						<div className="space-y-6">
							<h1 className="text-5xl font-semibold leading-none sm:text-6xl lg:text-7xl">
								AI Agents for{" "}
								<span className="text-primary">Developer Communities</span>
							</h1>
							<p className="max-w-xl text-lg text-muted-foreground sm:text-xl">
								Turn community noise into momentum. Squash keeps conversations
								buzzing, captures the magic from every thread, and nudges your
								community toward the next big thing.
							</p>
						</div>

						<div className="flex flex-col gap-4 sm:flex-row">
							<Button
								size="lg"
								className="gap-2 rounded-full px-8 py-6 text-base shadow-lg shadow-primary/20"
								asChild
							>
								<a href="https://form.typeform.com/to/tnUCbmX4">
									<Mail className="h-5 w-5" />
									Early Access
									<ArrowRight className="h-4 w-4" />
								</a>
							</Button>
							<Button
								size="lg"
								variant="outline"
								className="rounded-full border-primary/20 px-8 py-6 text-base shadow-sm shadow-primary/10 hover:border-primary/40 hover:bg-primary/5"
								onClick={() =>
									document
										.getElementById("how-it-works")
										?.scrollIntoView({ behavior: "smooth" })
								}
							>
								Learn More
							</Button>
						</div>
					</div>

					{/* Right column - Visual */}
					<div className="relative h-[420px] sm:h-[460px] lg:h-[560px]">
						<div className="absolute -inset-10 rounded-[40px] bg-[radial-gradient(circle_at_top,_rgba(15,157,138,0.25),_transparent_65%)] blur-2xl" />
						<div className="glass-panel relative flex h-full items-center justify-center overflow-hidden rounded-[32px] border border-white/70 shadow-float">
							<InteractiveGraph />
						</div>
						<div className="absolute -bottom-10 left-1/2 w-[260px] -translate-x-1/2 rounded-3xl border border-white/70 bg-white/80 px-5 py-4 text-sm shadow-lg shadow-primary/10 backdrop-blur-xl">
							<div className="mb-2 flex items-center gap-3">
								<div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
									<Users className="h-5 w-5 text-primary" />
								</div>
								<div>
									<p className="font-semibold text-foreground">
										Lively Threads
									</p>
									<p className="text-xs text-muted-foreground">
										+48% week-over-week
									</p>
								</div>
							</div>
							<p className="text-muted-foreground">
								Squash spots hot conversations, highlights wins, and pings you
								before energy fizzles out.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
